import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import CatalogInput from './input';

class Component extends BaseComponent {
    render({ inputs }) {
        if (inputs) {
            if (window.innerWidth > 576) { // tablet and desktop
                return (
                    <catalog-inputs>
                        <div class='row container main_wrapper'>
                            <div class='small-12 medium-6 columns'>
                                <div class='small-6 columns'>
                                    <CatalogInput input={inputs[0]} />
                                </div>
                                <div class='small-6 columns'>
                                    <CatalogInput input={inputs[1]} />
                                </div>
                            </div>
                            <div class='small-12 medium-6 columns'>
                                {this.renderSearch()}
                            </div>
                        </div>
                    </catalog-inputs>
                );
            }

            return (
                <catalog-inputs>
                    <div class='filters'>
                        <CatalogInput input={inputs[0]} />
                        <CatalogInput input={inputs[1]} />
                    </div>
                    <div class='row'>
                        <div class='small-12 columns'>
                            {this.renderSearch()}
                        </div>
                    </div>
                </catalog-inputs>
            );
        }

        return (<catalog-inputs />);
    }

    renderSearch() {
        return (
            <input
              type='search'
              name='search'
              placeholder='Search Products'
              onKeyUp={this.handleKeyUp}
            />
        );
    }

    handleKeyUp = (e) => {
        this.props.getFilter({ search: e.target.value });
    }
}

const mapStateToProps = (state) => ({
    inputs: state.catalog && state.catalog.inputs,
    filters: state.catalog && state.catalog.filter,
});

const mapDispatchToProps = (dispatch) => ({
    getFilter: (payload) => dispatch({ type: 'catalog:get-filter', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/catalog/inputs.js